const ENV_MAP = {
	development: {
		API: 'https://api-dev.oncallair.com',
		VERSION: 'version_1_197_11_OBCV-84_7ba434d',
		ENV: 'development',
		HOST_URL: 'https://oca-appv2-dev.oncallair.com',
		PUBLIC_KEY: 'WVudHMiXSwkdBR0UiLCJ1c2VyX2lkIjoXNlciJdfQLf88Iegu7LC8t2lcH9r_o70yUuRSVPZlYXR1cmVzzLCJ1',
		G_MAPS_KEY: 'AIzaSyCZcwjvu3dXcRf0KM8qt9tDVzg_YbK1UuA',
		G_TAG_ID: 'G-ZTQ5XT0EYV',
		G_TAG_URL: 'https://www.googletagmanager.com/gtag/js',
		C4C_EASY_LINK: 'https://8qavglzqq4.execute-api.us-east-1.amazonaws.com/dev/authenticate/easy-link',
		C4C_URL: 'https://app-stg.creditforcomfort.com',
		AWS_BUCKET_REGION: 'us-east-1',
		AWS_IDENTITY_POOL_ID: 'us-east-1:23cc3f1e-bcf0-4aef-920f-5265b68fc66f',
		AWS_FLEXJOB_BUCKET_NAME: 'job-images-dev',
		AWS_PUBLIC_NOTES_BUCKET_NAME: 'proposal-attachments',
		AWS_SURVEY_BUCKET_NAME: 'oca-attachments-dev',
		AWS_ACCESSORY_BUCKET_NAME: 'custom-accessory-dev',
		AWS_SERIES_BUCKET_NAME: 'oca-series-images',
		AWS_IMPORTER_BUCKET_NAME: 'oca-importer',
		AUTH0_CLIENT_ID: 'p6cwXm4Dwue7qCMrcp1xD5R3XCo8pjWB',
		AUTH0_DOMAIN: 'oca-dev.us.auth0.com',
	},
	staging: {
		API: 'https://api-stg.oncallair.com',
		VERSION: 'version_1_197_11_OBCV-84_7ba434d',
		ENV: 'staging',
		HOST_URL: 'https://oca-appv2-stg.oncallair.com',
		PUBLIC_KEY: 'WVudHMiXSwkdBR0UiLCJ1c2VyX2lkIjoXNlciJdfQLf88Iegu7LC8t2lcH9r_o70yUuRSVPZlYXR1cmVzzLCJ1',
		G_MAPS_KEY: 'AIzaSyCZcwjvu3dXcRf0KM8qt9tDVzg_YbK1UuA',
		G_TAG_ID: 'G-ZTQ5XT0EYV',
		G_TAG_URL: 'https://www.googletagmanager.com/gtag/js',
		C4C_EASY_LINK: 'https://8qavglzqq4.execute-api.us-east-1.amazonaws.com/dev/authenticate/easy-link',
		C4C_URL: 'https://app-stg.creditforcomfort.com',
		AWS_BUCKET_REGION: 'us-east-1',
		AWS_IDENTITY_POOL_ID: 'us-east-1:23cc3f1e-bcf0-4aef-920f-5265b68fc66f',
		AWS_FLEXJOB_BUCKET_NAME: 'job-images-stg',
		AWS_PUBLIC_NOTES_BUCKET_NAME: 'proposal-attachments',
		AWS_SURVEY_BUCKET_NAME: 'oca-attachments-stg',
		AWS_ACCESSORY_BUCKET_NAME: 'custom-accessory-stg',
		AWS_SERIES_BUCKET_NAME: 'oca-series-images',
		AWS_IMPORTER_BUCKET_NAME: 'oca-importer',
		AUTH0_CLIENT_ID: 'xwDdMi3BBgiM2IOmWuO1kxmH01Y8RR89',
		AUTH0_DOMAIN: 'oca-stage.us.auth0.com',
	},
	production: {
		API: 'https://api.oncallair.com',
		VERSION: 'version_1_197_11_OBCV-84_7ba434d',
		ENV: 'production',
		HOST_URL: 'https://app.oncallair.com',
		PUBLIC_KEY: 'WVudHMiXSwkdBR0UiLCJ1c2VyX2lkIjoXNlciJdfQLf88Iegu7LC8t2lcH9r_o70yUuRSVPZlYXR1cmVzzLCJ1',
		G_MAPS_KEY: 'AIzaSyCAdBZsEX-lNRigZjwYF8MHEiN6WcP_LFE',
		G_TAG_ID: 'G-ZTQ5XT0EYV',
		G_TAG_URL: 'https://www.googletagmanager.com/gtag/js',
		C4C_EASY_LINK: 'https://6is5gkfg1f.execute-api.us-east-1.amazonaws.com/prod/authenticate/easy-link',
		C4C_URL: 'https://app.creditforcomfort.com',
		AWS_BUCKET_REGION: 'us-east-1',
		AWS_IDENTITY_POOL_ID: 'us-east-1:23cc3f1e-bcf0-4aef-920f-5265b68fc66f',
		AWS_FLEXJOB_BUCKET_NAME: 'job-images-prod',
		AWS_PUBLIC_NOTES_BUCKET_NAME: 'proposal-attachments',
		AWS_SURVEY_BUCKET_NAME: 'oca-attachments-prod',
		AWS_ACCESSORY_BUCKET_NAME: 'custom-accessory-prod',
		AWS_SERIES_BUCKET_NAME: 'oca-series-images',
		AWS_IMPORTER_BUCKET_NAME: 'oca-importer',
		AUTH0_CLIENT_ID: 'kl0YlXJTGqMnxIautfSTmBHAAkPjgVmn',
		AUTH0_DOMAIN: 'oca-prod.us.auth0.com',
	},
	production_pre_check: {
		API: 'https://xyzapi.oncallair.com',
		VERSION: 'version_1_197_11_OBCV-84_7ba434d',
		ENV: 'production',
		HOST_URL: 'https://xyzapp.oncallair.com',
		PUBLIC_KEY: 'WVudHMiXSwkdBR0UiLCJ1c2VyX2lkIjoXNlciJdfQLf88Iegu7LC8t2lcH9r_o70yUuRSVPZlYXR1cmVzzLCJ1',
		G_MAPS_KEY: 'AIzaSyCAdBZsEX-lNRigZjwYF8MHEiN6WcP_LFE',
		G_TAG_ID: 'G-ZTQ5XT0EYV',
		G_TAG_URL: 'https://www.googletagmanager.com/gtag/js',
		C4C_EASY_LINK: 'https://6is5gkfg1f.execute-api.us-east-1.amazonaws.com/prod/authenticate/easy-link',
		C4C_URL: 'https://app.creditforcomfort.com',
		AWS_BUCKET_REGION: 'us-east-1',
		AWS_IDENTITY_POOL_ID: 'us-east-1:23cc3f1e-bcf0-4aef-920f-5265b68fc66f',
		AWS_FLEXJOB_BUCKET_NAME: 'job-images-prod',
		AWS_PUBLIC_NOTES_BUCKET_NAME: 'proposal-attachments',
		AWS_SURVEY_BUCKET_NAME: 'oca-attachments-prod',
		AWS_ACCESSORY_BUCKET_NAME: 'custom-accessory-prod',
		AWS_SERIES_BUCKET_NAME: 'oca-series-images',
		AWS_IMPORTER_BUCKET_NAME: 'oca-importer',
		AUTH0_CLIENT_ID: '2gMnmgGGYiS7COyeEGHftOxOqMVWKCWS',
		AUTH0_DOMAIN: 'oca-xyz.us.auth0.com',
	},
};

const envName = (typeof window !== 'undefined' && window.__ENV__) || 'development';
const cfg = ENV_MAP[envName] || ENV_MAP.development;

let compMod = angular
	.module('env.constants', [])
	.constant('API', cfg.API)
	.constant('VERSION', cfg.VERSION)
	.constant('ENV', cfg.ENV)
	.constant('HOST_URL', cfg.HOST_URL)
	.constant('PUBLIC_KEY', cfg.PUBLIC_KEY)
	.constant('SOURCE', 'webapp')
	.constant('G_MAPS_KEY', cfg.G_MAPS_KEY)
	.constant('G_TAG_ID', cfg.G_TAG_ID)
	.constant('G_TAG_URL', cfg.G_TAG_URL)
	.constant('C4C_EASY_LINK', cfg.C4C_EASY_LINK)
	.constant('C4C_URL', cfg.C4C_URL)
	.constant('AWS_FLEXJOB_BUCKET_NAME', cfg.AWS_FLEXJOB_BUCKET_NAME)
	.constant('AWS_PUBLIC_NOTES_BUCKET_NAME', cfg.AWS_PUBLIC_NOTES_BUCKET_NAME)
	.constant('AWS_BUCKET_REGION', cfg.AWS_BUCKET_REGION)
	.constant('AWS_IDENTITY_POOL_ID', cfg.AWS_IDENTITY_POOL_ID)
	.constant('AWS_IMPORTER_BUCKET_NAME', cfg.AWS_IMPORTER_BUCKET_NAME)
	.constant('AWS_SERIES_BUCKET_NAME', cfg.AWS_SERIES_BUCKET_NAME)
	.constant('AWS_ACCESSORY_BUCKET_NAME', cfg.AWS_ACCESSORY_BUCKET_NAME)
	.constant('AWS_SURVEY_BUCKET_NAME', cfg.AWS_SURVEY_BUCKET_NAME)
	.constant('AUTH0_CLIENT_ID', cfg.AUTH0_CLIENT_ID)
	.constant('AUTH0_DOMAIN', cfg.AUTH0_DOMAIN);
export default (compMod = compMod.name);
